import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=5dba6fb8&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba6fb8",
  null
  
)

export default component.exports